import { User } from "../../../contexts/Users/helper";

export const getVisibleUsers = (users: User[], search: string) => {
  const text = search.toLowerCase();

  return users.filter((user) => user.name.toLowerCase().includes(text) || user.email.toLowerCase().includes(text) || user.phoneNumber.toLowerCase().includes(text)).sort((a, b) => a.name.localeCompare(b.name));
}
